<template>

  <div class="metadata_container">

    <v-treeview
      class   = "metadata_tree"
      dense
      dark
      :items  = "metadata"
      open-on-click
    >
    </v-treeview>

  </div>

</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

// #endregion Imports

export default {
  
  // #region Properties

  name:     'FrameInfo',
  computed: {
    ...mapState([
      'video'
    ]),
    metadata() {
      return this.video.frameMetadata.map(e => this.mapProperty(e));
    }
  },

  // #endregion Properties

  // #region Operations

  methods: {

    mapProperty(property) {
      const result = {};

      result.name = property.name;

      if (property.description != null) {
        result.name = `${property.name}: ${property.description}`;
      } else if (property.value != null) {
        result.name = `${property.name}: ${property.value}`;
      }

      // If there are no children, we are done.
      if ((!property.children) || (property.children.length < 1)) {
        return result;
      }

      result.children = property.children.map(c => this.mapProperty(c));

      // TODO: Why?
      if (result.name === 'type') {
        if (property.children[0].description !== null) {
          result.name = property.children[0].description;
        } else {
          result.name = property.children[0].value;
        }

        result.children.shift();
      }

      return result;
    }
  }

  // #endregion Operations

}

</script>

<style lang="scss" scoped>

.metadata_container {
  padding:      8px;
  position:     relative;

  font-size:    0.7rem; 
  font-family:  monospace !important;

  .metadata_tree {
    position:     absolute;
    top:          0;
    bottom:       0;
    left:         0;
    right:        0;
    overflow:     auto;
  }
}

</style>